import { createContext } from 'react'

import type { User } from '../api/client'

export interface AuthValue {
  user: User | null
  /** True until the first /auth/me answers, so we never flash the login form
   *  at someone who is already signed in. */
  loading: boolean
  signIn: (username: string, password: string) => Promise<void>
  signOut: () => Promise<void>
  /** Re-read the session, e.g. after a password change clears the flag. */
  refresh: () => Promise<void>
}

export const AuthContext = createContext<AuthValue | null>(null)
